import { get } from "@/utils/httpRequest";

const prefix = process.env.VUE_APP_API_URL + "/misc";

const getAllFirmUri = prefix + "/all_firm";

//获取所有市场
const getAllFirm = () => get(getAllFirmUri, {}, { showLoading: false });

export default {
  getAllFirm
};
